import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateScheduledShowDocument } from './create.generated';

export const useCreateScheduledShow = (
  options: ApiOptions<typeof CreateScheduledShowDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(CreateScheduledShowDocument, {
    ...useNotifications(CreateScheduledShowDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        t('api.scheduled_show.create_success_with_devices_plural', {
          count: data.createScheduledShow?.devices.length ?? 0,
        }),
    }),

    ...options,
  });
};
